// extracted by mini-css-extract-plugin
export default {"icon":"useCloseConfirmationModal_icon__czeL1","title":"useCloseConfirmationModal_title__Cssmx","content":"useCloseConfirmationModal_content__YBkS+"};